import { t } from '@lingui/core/macro';
import { NoddiButton, NoddiIconButton } from 'noddi-ui-web';
import { getGoogleMapsUrlFromCoordinates } from 'noddi-util';

type Props = {
  pinLocation?: { lat: number; lng: number };
  onOpenPicker: () => void;
};

export const MapPinLocationControl = ({ pinLocation, onOpenPicker }: Props) => (
  <div className='flex flex-col items-start gap-1.5'>
    <NoddiButton variant='outline' size='small' startIcon='MapPin' onClick={onOpenPicker}>
      {pinLocation ? t`Edit marker` : t`Mark where car is parked`}
    </NoddiButton>

    {pinLocation && (
      <div className='flex flex-col gap-0.5'>
        <span className='text-xs font-medium text-muted-foreground'>{t`Car location`}</span>
        <span className='inline-flex items-center gap-2'>
          <span className='font-mono text-xs text-gray-700'>
            Lat: {pinLocation.lat.toFixed(6)} | Lng: {pinLocation.lng.toFixed(6)}
          </span>
          <NoddiIconButton asChild iconName='Map' size='small' variant='subtle'>
            <a
              href={getGoogleMapsUrlFromCoordinates(pinLocation.lat, pinLocation.lng)}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={t`Open in Google Maps (opens in a new tab)`}
            />
          </NoddiIconButton>
        </span>
      </div>
    )}
  </div>
);
